class AppFooterController {
  constructor() {
    this.name = 'appFooter';
  }
}

export default AppFooterController;



// WEBPACK FOOTER //
// ./app/common/appFooter/appFooter.controller.js